// function getSongs(symbolMani) {
//     const baseUrl = 'https://binance43.p.rapidapi.com';
// const endPoint = '/ticker/price';
// const params = new URLSearchParams({
//     symbol: symbolMani,

// });

// const url = `${baseUrl}${endPoint}?${params}`;

// const options = {
//     headers: {
// 		'x-rapidapi-key': '77a19c2619msh6fcc65e054db545p13d384jsn4db52fbf1d5c',
// 		'x-rapidapi-host': 'binance43.p.rapidapi.com',
// 		'Content-Type': 'application/json'
// 	}
// }

//      return fetch(url, options).then(res => res.json());


// }
// getSongs("BTCUSDT").then(res => console.log(res));
// getSongs("BNBUSDT");

//!==============================

const refs = {
    formEl: document.querySelector(".js-hero-form"),
    heroEl: document.querySelector(".js-hero-container")
}

//!==================================
refs.formEl.addEventListener("submit", (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const value = formData.get('query');
    searchHero(value).then(data => {
        const markup = heroTemplate(data);
        refs.heroEl.insertAdjacentHTML("afterbegin", markup);
    })

})


//!================================================
function searchHero(query) {
   const BASE_URL = 'https://superhero-search.p.rapidapi.com';
   const END_POINT = '/api/';
   const params = new URLSearchParams({
     hero: query,

    
   });
   const url = BASE_URL + END_POINT + '?' + params;
  console.log(url);
   const options = {
     headers: {
		'x-rapidapi-key': '77a19c2619msh6fcc65e054db545p13d384jsn4db52fbf1d5c',
		'x-rapidapi-host': 'superhero-search.p.rapidapi.com',
		'Content-Type': 'application/json'
	}
   };
  
   return fetch(url, options).then(res => res.json());
   

}
//searchHero("spaiderman").then(res => console.log(res));
//!=============================================

function heroTemplate(hero) {
    const { appearance, biography, images, name, powerstats } = hero;
    return `<div class="hero-card card">
    <div class="image-container">
        <img
          src="${images.lg}"
          alt="#"
          class="hero-image"
        />
     </div>
     <div class="hero-body">
        <h4 class="hero-name">${name}</h4>

        <div class="hero-powerstats">
            <p class="hero-bio">FullName - ${biography.fullName}</p>
            <p class="hero-bio">Publisher - ${biography.publisher}</p>
            <p class="hero-bio">Alignment - ${biography.alignment}</p>
            <p class="hero-bio">Gender - ${appearance.gender}</p>
            <p class="hero-bio">Race - ${appearance.race}</p>


        </div>
        <div class="hero-powerstats">
            <span>Power: ${powerstats.power}</span>
            <span>Strength: ${powerstats.strength}</span>
            <span>Speed: ${powerstats.speed}</span>
            <span>Combat: ${powerstats.combat}</span>

        </div>
      </div>
   </div>`
    
} 


